<temptik-home></temptik-home>
<temptik-solution></temptik-solution>
<div class="white-bg-color">
  <temptik-features id="features"></temptik-features>
</div>
<div class="white-bg-color purple-waves-bg">
  <temptik-pricing class="purple-waves-content" id="pricing"></temptik-pricing>
</div>
